// extracted by mini-css-extract-plugin
export default {"IntroLoad":"IntroLoad_IntroLoad__RZ0KI","slideDown":"IntroLoad_slideDown__aTTCI"};